/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatSettingsOverrides } from './ChatSettingsOverrides';
import {
    ChatSettingsOverridesFromJSON,
    ChatSettingsOverridesFromJSONTyped,
    ChatSettingsOverridesToJSON,
    ChatSettingsOverridesToJSONTyped,
} from './ChatSettingsOverrides';
import type { ChatTurn } from './ChatTurn';
import {
    ChatTurnFromJSON,
    ChatTurnFromJSONTyped,
    ChatTurnToJSON,
    ChatTurnToJSONTyped,
} from './ChatTurn';

/**
 * 
 * @export
 * @interface SimpleChatRequestDto
 */
export interface SimpleChatRequestDto {
    /**
     * 
     * @type {Array<ChatTurn>}
     * @memberof SimpleChatRequestDto
     */
    history: Array<ChatTurn>;
    /**
     * 
     * @type {ChatSettingsOverrides}
     * @memberof SimpleChatRequestDto
     */
    overrides?: ChatSettingsOverrides | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    modelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    threadId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    readonly lastUserQuestion?: string | null;
}

/**
 * Check if a given object implements the SimpleChatRequestDto interface.
 */
export function instanceOfSimpleChatRequestDto(value: object): value is SimpleChatRequestDto {
    if (!('history' in value) || value['history'] === undefined) return false;
    return true;
}

export function SimpleChatRequestDtoFromJSON(json: any): SimpleChatRequestDto {
    return SimpleChatRequestDtoFromJSONTyped(json, false);
}

export function SimpleChatRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleChatRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'history': ((json['history'] as Array<any>).map(ChatTurnFromJSON)),
        'overrides': json['overrides'] == null ? undefined : ChatSettingsOverridesFromJSON(json['overrides']),
        'modelId': json['modelId'] == null ? undefined : json['modelId'],
        'threadId': json['threadId'] == null ? undefined : json['threadId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'lastUserQuestion': json['lastUserQuestion'] == null ? undefined : json['lastUserQuestion'],
    };
}

export function SimpleChatRequestDtoToJSON(json: any): SimpleChatRequestDto {
    return SimpleChatRequestDtoToJSONTyped(json, false);
}

export function SimpleChatRequestDtoToJSONTyped(value?: Omit<SimpleChatRequestDto, 'lastUserQuestion'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'history': ((value['history'] as Array<any>).map(ChatTurnToJSON)),
        'overrides': ChatSettingsOverridesToJSON(value['overrides']),
        'modelId': value['modelId'],
        'threadId': value['threadId'],
        'userName': value['userName'],
    };
}

